import surveyFeatureFlags from './SurveyFeatureFlags';

export default surveyFeatureFlags;
